// Firebase configuration for RecargameYa PWA
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyANZt6QLGEtRUz5H3z6qGgtVDKSRT4F_Kw",
  authDomain: "recargameya.firebaseapp.com",
  projectId: "recargameya",
  storageBucket: "recargameya.firebasestorage.app",
  messagingSenderId: "247853438553",
  appId: "1:247853438553:web:039b1231c9cb1896c98348"
};

const VAPID_KEY = "BETniMlyfEyd7TkV_GNJs-2QHiATxS8NRFeTINwsv6J2l_gsyP-M7PJ_KanrP0JyHLD2EUNg7GXWz9jGYcqkgYA";

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Detect if we are inside the Android native shell (WebView) — Firebase
// Messaging cannot work there because it depends on Service Workers +
// Notifications API which the WebView does not expose. Calling getMessaging()
// throws an unhandled error that shows the react-error-overlay red screen.
const _isNativeShell = () => {
  if (typeof window !== 'undefined' && window.AndroidPrinter) return true;
  if (typeof navigator !== 'undefined' && /RecargameYaApp\//.test(navigator.userAgent || '')) return true;
  return false;
};

// Get messaging instance
let messaging = null;
let messagingSupported = null; // null=unknown, true/false=resolved

const _resolveSupport = async () => {
  if (messagingSupported !== null) return messagingSupported;
  if (_isNativeShell()) {
    messagingSupported = false;
    return false;
  }
  try {
    messagingSupported = await isSupported();
  } catch {
    messagingSupported = false;
  }
  return messagingSupported;
};

export const initializeMessaging = async () => {
  const ok = await _resolveSupport();
  if (!ok) return null;
  try {
    if (!messaging) messaging = getMessaging(app);
    return messaging;
  } catch (error) {
    console.log('Firebase messaging not supported:', error?.message || error);
    return null;
  }
};

// Request permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    if (typeof Notification === 'undefined') return null;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    const m = await initializeMessaging();
    if (!m) {
      console.log('Messaging not available');
      return null;
    }

    // Get FCM token
    const token = await getToken(m, { vapidKey: VAPID_KEY });
    console.log('FCM Token:', token);
    return token;
  } catch (error) {
    console.log('Error getting FCM token:', error?.message || error);
    return null;
  }
};

// Listen for foreground messages
export const onForegroundMessage = (callback) => {
  // Kick off async init but never let a rejection escape as an uncaught error.
  initializeMessaging()
    .then((m) => {
      if (!m) return;
      try {
        onMessage(m, (payload) => {
          console.log('Foreground message received:', payload);
          callback(payload);
        });
      } catch (e) {
        console.log('onMessage subscribe failed:', e?.message || e);
      }
    })
    .catch((e) => console.log('initializeMessaging failed:', e?.message || e));
  // We can't return a real unsubscribe synchronously; caller ignores it.
  return null;
};

export default app;
